function trackSearchTerm(searchTerm, numResults) {
  if (window.analytics && searchTerm && numResults) {
    window.analytics.track("Product Searched", {
      search_term: searchTerm,
      results_count: numResults,
    });
  }
}

function trackSiteSearchClicked(searchInput, location) {
  if (window.analytics) {
    window.analytics.trackLink(searchInput, "Site Search Clicked", {
      location: location,
    });
  }
}

function getCurrentPageType() {
  const bodyClass = document.body.className;
  const pageTypeMap = {
    "cms-index-index": "Homepage",
    "catalog-category-view": "Category Page",
    "catalog-product-view": "Product Page",
    "catalogsearch-result-index": "Search Results Page",
    "customer-account-index": "Customer Account Page",
    "wishlist-index-index": "Wishlist Page",
    "cms-page-view": "CMS Page",
  };

  for (const key in pageTypeMap) {
    if (bodyClass.includes(key)) {
      return pageTypeMap[key];
    }
  }

  return "Other Page";
}

export { trackSearchTerm, trackSiteSearchClicked, getCurrentPageType };
